import React, { useMemo } from 'react'
import { useTable, usePagination } from 'react-table'
import { COLUMNS } from './testimonialColumn'
import { Button,  Table } from 'reactstrap';
import { BiEditAlt, BiTrash } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';

export const TestimonialPaginationTable = ({data, deleteAction}) => {
  const columns = useMemo(() => COLUMNS, [])
  const navigate = useNavigate();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 1, pageSize: 5 }
    },
    usePagination
  )

  const { pageIndex, pageSize } = state
  return (
    <>
      <Table responsive hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={i}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            console.log("Data" + row)
            prepareRow(row)
            return (
              <>
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map(cell => {
                  return (<>
                    {
                      cell.column.Header === 'Author Image' ?  <td><img style={{width: 120}} src={process.env.REACT_APP_API_IMAGE_URI.substring(0, process.env.REACT_APP_API_IMAGE_URI.indexOf("/api")) 
                            + `${row.original.authorImg.substring(row.original.authorImg.indexOf("/uploads"))}`} 
                            alt={row.original.authorName}></img></td> : <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    }
                  </>
                  )
                })}
                <td>
                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/testimonials/edit/${row.original.id}`)} size={30}/> 
                <BiTrash
                    className="delete_icon icon_hover"
                    onClick={(event) => deleteAction(event, row.original.id)}
                    size={20}
                  />
                </td>

              </tr>
              
              </>
            )
          })}
        </tbody>
      </Table>
      <div className="text-center">
        <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </Button>{' '}
        <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
          Previous
        </Button>{' '}
        <Button onClick={() => nextPage()} disabled={!canNextPage}>
          Next
        </Button>{' '}
        <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </Button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type='number'
            defaultValue={pageIndex}
            onChange={e => {
              const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(pageNumber)
            }}
            style={{ width: '50px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => setPageSize(Number(e.target.value))}>
          {[5].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}